(function () {
    'use strict';
    var m = angular.module('dao');
    m.factory('avananUserHelper', ["$q", "modals", "$rootScope", "autologinHelper", "routeHelper", function ($q, modals, $rootScope, autologinHelper, routeHelper) {
        var avananUserHelper = {
            errorModal: function (input, args) {
                if (input && input.data) {
                    if (input.data.error && input.data.error.message) {
                        if (!$rootScope.errModalIsOn) {
                            $rootScope.errModalIsOn = true;
                            var modalOptions = {
                                display: 'html',
                                notCloseOnRouteChange: true,
                                title: input.data.error.description || '',
                                backdrop: 'static'
                            };
                            if (autologinHelper.checkAutologinType()) {
                                modalOptions.disableCloseX = true;
                                modalOptions.disableCloseBtn = true;
                                modalOptions.windowClass = 'dark-background';
                                modals.alert(input.data.error.message, modalOptions);
                                routeHelper.redirectTo('blank');
                            } else {
                                modals.alert(input.data.error.message, modalOptions);
                                routeHelper.redirectTo('auth', { page: 'login' });
                                return $q.reject();
                            }
                        } else {
                            if (!autologinHelper.checkAutologinType()) {
                                return $q.reject();
                            }
                        }
                    } else if (input.data.suspended) {
                        if (!$rootScope.errModalIsOn) {
                            $rootScope.errModalIsOn = true;
                            var modalOptions1 = {
                                display: 'html',
                                notCloseOnRouteChange: true,
                                title: 'Login Failure',
                                backdrop: 'static'
                            };
                            var suspendedTxt = 'This portal has been suspended. All configurations and security activities have been disabled. ' + 'To check how to reactivate your portal please contact Support.';
                            if (autologinHelper.checkAutologinType()) {
                                modalOptions1.disableCloseX = true;
                                modalOptions1.disableCloseBtn = true;
                                modalOptions1.windowClass = 'dark-background';
                                modals.alert(suspendedTxt, modalOptions1);
                                routeHelper.redirectTo('blank');
                            } else {
                                modals.alert(suspendedTxt, modalOptions1);
                                routeHelper.redirectTo('auth', { page: 'login' });
                                return $q.reject();
                            }
                        } else {
                            if (!autologinHelper.checkAutologinType()) {
                                return $q.reject();
                            }
                        }
                    }
                }
                return $q.when(input);
            }
        };
        return avananUserHelper;
    }]);
}());